import React from 'react';
import { compose } from 'ramda';

import styleFile from './AvailRoomDetailModal.js';
import { Image, Button, RichText } from '@synergycms_core/components/generic/';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import Modal from '@synergycms_core/components/generic/Modal';
import AmenitiesList from '../../AmenitiesList';
import Tabs, { Tab } from '../../../generic/TabList';
import Slide, { SlideItem, ButtonSlide } from '@synergycms_core/components/generic/Slide';
import Icon from '@synergycms_core/components/generic/Icon';
import ModalMedia from '../../ModalMedia/ModalMedia.jsx';

export const RoomInfoBlock = compose(
  PropertyManager(['roomInfo']),
  withThemeJSS({ styleFile, displayName: 'ModalRoomMedia' }, null, 'tabTitle')
)(
  class RoomInfoBlock extends React.Component {
    static displayName = 'RoomInfoBlock';

    constructor(props) {
      super(props);
      this.state = {
        modalDescriptionBlock: true,
        modalServicesBlock: true
      };
    }

    toggleModalDescription = e => {
      e.preventDefault();
      this.setState(state => ({
        modalDescriptionBlock: !state.modalDescriptionBlock
      }));
    };

    toggleModalServices = e => {
      e.preventDefault();
      this.setState(state => ({
        modalServicesBlock: !state.modalServicesBlock
      }));
    };

    render() {
      const { roomInfo } = this.props.config;
      const { classes } = this.props.theme.styles;
      return (
        <div>
          {roomInfo.get('description') && (
            <div className={classes.infoBlock}>
              <div className={classes.serviceInfoWithImage}>
                <Button
                  onClick={this.toggleModalDescription}
                  richText={{
                    text: '_%descripción%_',
                    ucFirst: true,
                    innerStyle: ['roboto24Bold400Black', 'bold'],
                    rightIcon: {
                      unicodeContent: this.state.modalDescriptionBlock ? 'e02e' : 'e0f8',
                      innerStyle: ['mainColor', 'size12', 'marginLeft5']
                    },
                    translate: true
                  }}
                />
                <span className={classes.titleSpace} />
                {this.state.modalDescriptionBlock && (
                  <RichText dangerouslySetInnerHTML={roomInfo.get('description')} innerStyle={['roboto14Black']} />
                )}
              </div>
            </div>
          )}
          {!!roomInfo.get('amenities').size && (
            <div className={classes.infoBlock}>
              <div className={classes.serviceInfoWithImage}>
                <Button
                  onClick={this.toggleModalServices}
                  richText={{
                    ucFirst: true,
                    text: '_%servicios%_',
                    innerStyle: ['roboto24Bold400Black', 'bold'],
                    rightIcon: {
                      unicodeContent: this.state.modalServicesBlock ? 'e02e' : 'e0f8',
                      innerStyle: ['gold', 'size12', 'marginLeft5']
                    },
                    translate: true
                  }}
                />
                {this.state.modalServicesBlock && (
                  <AmenitiesList
                    maxAmenities={roomInfo.get('amenities').size}
                    list={roomInfo.get('amenities')}
                    innerStyle={['servicesList']}
                  />
                )}
              </div>
            </div>
          )}
        </div>
      );
    }
  }
);

const TabTitleSlide = props => (
  <span>
    <Icon unicodeContent={'e14c'} innerStyle={['size18']} />
    <RichText
      plural={props.totalPhotos}
      text={'_%foto%_'}
      translate={true}
      innerStyle={['mainColor', 'roboto16Black400', 'uppercase']}
    />
    <RichText
      text={' (' + props.activePhoto + ' / ' + props.totalPhotos + ')'}
      innerStyle={['roboto16SoftGray400', props.classes.photoCounter]}
    />
  </span>
);

const AvailRoomDetailModal = class AvailRoomDetailModal extends React.Component {
  static displayName = 'AvailRoomDetailModal';

  constructor(props) {
    super(props);
    this.state = {
      selectedPhoto: 0,
      width:null,
    };
    this.widthRef = React.createRef();
  }

  propagateSelectedPhoto = key => {
    this.setState((state, props) => ({
      selectedPhoto: key
    }));
  };

  getWidthComponent = () => {
    if(this.widthRef.current){
      this.setState({ 
        width: this.props.theme.getDesirableWidth(this.widthRef.current.offsetWidth)
      });
    }
  }

  componentDidMount() {
    this.getWidthComponent();
  }

  render() {
    const { config, classes } = this.props;
    const resizableImages = this.props.resizableImages && this.state.width ? this.state.width : '';
    return (
      <div className={classes.modalTabsList} ref={this.widthRef}>
        <div className={classes.headerModal}>
          <RichText innerStyle={classes.modalTitle} text={config.roomName} />
        </div>
        <Tabs titleBlockStyle={classes.monoHotelList}>
          {config.roomInfo.get('photo') && (
            <Tab
              contentKey={1}
              tabTitle={
                <TabTitleSlide
                  classes={classes}
                  totalPhotos={config.roomInfo.get('photos').size}
                  activePhoto={this.state.selectedPhoto + 1}
                />
              }
              key={1}
              innerStyle={classes.availRoomDetailTab}>
              <div className={classes.mediaBlock}>
                <Slide wrapperContent={classes.detailModal} propagateSelectedKey={this.propagateSelectedPhoto} transitionSpeed={300}>
                  {config.roomInfo.get('photos').map((urlImage, i) => {
                    return (
                      <SlideItem key={urlImage} contentKey={urlImage}>
                        <Image
                          innerStyle={classes.backgroundModalImage}
                          noDefaultStyle={true}
                          backgroundImage={urlImage + resizableImages}
                          alt={[config.roomName, '_', i + 1].join('')}
                        />
                      </SlideItem>
                    );
                  })}
                  <div className={classes.availRoomDetailTabButton}>
                    <ButtonSlide
                      icon={{
                        unicodeContent: 'e000',
                        innerStyle: ['size13']
                      }}
                      direction={'next'}
                      innerStyle={classes.topButton}
                    />
                    <ButtonSlide
                      icon={{
                        content: '\\',
                        innerStyle: ['size13']
                      }}
                      direction={'prev'}
                      innerStyle={classes.botButton}
                    />
                  </div>
                </Slide>
              </div>
              <div className={classes.enlargeButton}>
                <ModalMedia
                  mediaEntity={config.roomInfo}
                  innerStyle={classes.buttonImage}
                  icon={{ unicodeContent:config.roomInfo.get('photos').size > 1 ? 'e043' : null }}
                />
              </div>
            </Tab>
          )}
        </Tabs>
        <RoomInfoBlock roomInfo={config.roomInfo} />
      </div>
    );
  }
};

const ModalRoomMedia = class ModalRoomMedia extends React.Component {
  static displayName = 'ModalRoomMedia';
  render() {
    const { config, theme } = this.props;
    const { classes } = theme.styles;
    const ButtonContent = config.buttonContent;
    const resizableImages = theme.resizableImages;
    
    return (
      <Modal
        contentStyle={classes.availModalcontent}
        closeButtonStyle={[classes.closeButton, 'mainColor']}
        modalStyle={classes.hotelModalStyle}
        popover={closeMethod => <AvailRoomDetailModal theme={theme} classes={classes} config={config} resizableImages={resizableImages}/>}
        typeModal={'roomDetailTooltip'}>
        <Button ariaLabel={'ModalRoomMedia'} tabIndex={-1}>
          <ButtonContent />
        </Button>
      </Modal>
    );
  }
};

export default compose(
  PropertyManager(['roomInfo', 'roomName', 'hotelInfo', 'buttonContent','travelClubEnabled']),
  withThemeJSS({ styleFile, index: 200 })
)(ModalRoomMedia);
